import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import Style from 'style-it'
import {EventInfo} from '../../components/eventInfo/EventInfo';
import {EventSummary} from '../../components/eventSummary/EventSummary';
import {FloatingComponents} from '../../components/floatingComponents/FloatingComponents';
import {RaceDistances} from '../../components/raceDistances/RaceDistances';
import {Schedule} from '../../components/schedule/Schedule';
import {Courses} from '../../components/ELP/courses/Courses';
import {Locations} from '../../components/ELP/locations/Locations';
import {styles} from './styles';
import {colors} from '../../shared/styles';
import {Sponsors} from '../../components/sponsors/Sponsors';
import {isLoggedIn} from '../../utils/isLoggedIn';
import {canAddEventDate} from '../../components/cTABox/CTABox';
import {isInFuture, isTodayOrFuture} from '../../utils/date';
import { trackGoogleEvent } from '../../utils/googleEvents';
import _ from 'lodash';
import { ELP } from '../../components/structuredData/ELP';
import {AddEventResultsButton} from '../../components/shared/AddEventResultsButton';
import {LogInOrSignUpIndependent} from '../../components/modal/LogInOrSignUpIndependent';
import { showModal } from '../../actions/modalActions'
import { ModalTypes } from '../../actions/types'
import { ElpResults } from '../../components/elpResults/ElpResults';

const mapStateToProps = () => ({
  dispatch: undefined
});

class EventAboutPageComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  state = {
    loginOpen: false
  };

  scheduleOrDistances(event, courses) {
    const {
      t
    } = this.props;

    return isTodayOrFuture(event.startTime)
      ? <Schedule event={event} courses={courses} />
      : <RaceDistances event={event} t={t} />;
  }

  /**
   * Checks if event has future date
   * @return boolean
   */
  hasFutureEventDate() {
    const {masterEvent: {nextRaceDate}} = this.props;

    return isInFuture(nextRaceDate);
  }

  addEventResultsModal = () => {
    const {
      dispatch,
      isMobile,
      masterEvent
    } = this.props

    dispatch(showModal({
      modalProps: {
        currentPage: 0,
        event: {...masterEvent, country: masterEvent.countryName, state: masterEvent.stateProvAbbrev},
        isMobile,
        noScroll: true
      },
      modalType: ModalTypes.ADD_EVENT_WIZARD,
      pages: 2
    }))
  }

  render() {
    const {
      masterEvent,
      masterId,
      isMobile,
      courses,
      eventsObj,
      // eslint-disable-next-line
      athlete: {},
      eventCourses,
      result,
      sponsorLogos,
      t
    } = this.props;

    const styleRow = {
      paddingTop: !isMobile ? '' : 10,
    };

    const thirdPartyRegLink = masterEvent && masterEvent.currentRace && masterEvent.currentRace.thirdPartyRegLink;
    const CTLiveLink = thirdPartyRegLink ? thirdPartyRegLink : eventCourses.CTLiveRegistrationLink;
    const siteURL = masterEvent.currentRace && masterEvent.currentRace.siteUri;

    const isExternalURL = siteURL && (siteURL.toLowerCase().indexOf('http://') === 0 || siteURL.toLowerCase().indexOf('https://') === 0);

    const realURL = !isExternalURL ? 'http://' + siteURL : siteURL;
    const currRace = masterEvent && masterEvent.currentRace;

    const isInFutureVal = isInFuture(masterEvent.currentRace && masterEvent.currentRace.startTime);

    const displayLearnMoreOrRegisterButton = (CTLiveLink && isInFutureVal) || siteURL;

    const isDifferentEvent = (eventsObj.current !== eventsObj.next);

    const canShowLeftColumn =
      (courses && courses.schedules && courses.schedules.length) ||
      (result && result.races && result.races.length) ||
      (courses && courses.locations && courses.locations.length);
    const forceRegisterHideArray = ['115192'];

    const forceHidingRegisterButton = forceRegisterHideArray.includes(masterId);

    // TODO: get rid of inline
    const rightColumnStyle = _.assign(
      {},
      styles.rightCol(canShowLeftColumn && !isMobile),
      styles.contentCard(isMobile),
      {padding: isMobile ? '15px' : ''}
    );

    const leftColumnStyle = _.assign(
      {},
      styleRow,
      styles.contentCard(isMobile),
      {padding: isMobile ? '15px' : ''}
    );

    const weatherStyle = canShowLeftColumn ? {} : {paddingTop: 42};

    return (
      <div>
      {
        isMobile &&
        <div id='sticky-footer' style={styles.stickyFooter}>
          <LearnMoreRegisterShare
            CTLiveLink={CTLiveLink}
            isInFutureVal={isInFutureVal}
            forceHidingRegisterButton={forceHidingRegisterButton}
            realURL={realURL}
            siteURL={siteURL}
            isMobile={isMobile}
            showButton={displayLearnMoreOrRegisterButton}
            t={t}
          />
       </div>
      }

      <div className="container" style={{paddingRight: isMobile ? '' : '0'}}>
        <ELP
          event={currRace}
          sponsors={sponsorLogos}
        />

        <div className="row">
          <div className={isMobile ? 'col-12' : 'col-9'} style={isMobile ? {} : styles.leftContainer}>
            <div>
              <div>
                <LogInOrSignUpIndependent
                  closeAction={() => this.setState({loginOpen: false})}
                  open={this.state.loginOpen}
                  isMobile={isMobile}
                  t={t}
                />
                {
                  isDifferentEvent &&
                  <div
                    className={isMobile ? 'col-12' : 'col-12 pl-0 pt-0'}
                    style={styles.contentCard(isMobile)}>
                    <EventSummary
                      event={masterEvent.currentRace}
                    />
                  </div>
                }
                {
                  isMobile &&
                  <div className="col-12" style={styles.contentCard(isMobile)}>
                    <div>
                    <ElpResults
                      event={masterEvent.currentRace}
                      isMobile={isMobile}
                    />
                    <AddEventResultsButton
                        t={t}
                        isMobile={isMobile}
                        callback={
                          () => {
                            trackGoogleEvent('ELP', 'Click', 'addMissingResults');
                            isLoggedIn() ?
                              this.addEventResultsModal()
                              : this.setState({...this.state, loginOpen: true});
                          }
                        }
                      />
                    </div>
                  </div>
                }
              </div>
              <div className={isMobile ? 'row mx-0' : 'row'}>
                {
                  // Left Column - Schedule, etc...
                }
                {
                  canShowLeftColumn ?
                  <div className={isMobile ? 'col-12' : 'col-6'} style={leftColumnStyle}>
                    {
                      isDifferentEvent && masterEvent &&
                      this.scheduleOrDistances(masterEvent.currentRace, courses)
                    }
                    {
                      canAddEventDate(masterEvent.currentRace) && isMobile &&
                      <FloatingComponents
                        event={masterEvent.currentRace}
                        isMobile={isMobile}
                        t={t}
                      />
                    }
                    {
                      courses && courses.locations ?
                      <Locations
                        isMobile={isMobile}
                        courses={courses}
                        t={t}
                      />
                      :
                      null
                    }
                  </div>
                  :
                  null
                }
                {
                  // Right Column
                }
                <div className={isMobile ? 'col-12' : 'col-6'} style={rightColumnStyle}>
                  {
                    canAddEventDate(masterEvent.currentRace) && !isMobile &&
                    <FloatingComponents
                      event={masterEvent.currentRace}
                      isMobile={isMobile}
                      t={t}
                    />
                  }
                  <EventInfo
                    event={masterEvent.currentRace}
                    style={weatherStyle}
                    t={t}
                  />
                </div>
              </div>
              {
                // Course maps
              }
              {
                isDifferentEvent && !_.isEmpty(courses) && !_.isEmpty(courses.courseMaps) &&
                <div className={`row ${isMobile ? 'mx-0' : ''}`}>
                  <div className='col-12' style={!isMobile ? {} : styles.contentCard(isMobile)}>
                    <Courses
                      isMobile={isMobile}
                      courses={courses}
                      t={t}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
          {
            // Sidebar content
          }
          {
            !isMobile &&
            <div className={isMobile ? 'col-12' : 'col-3'}>
              <div style={{
                ...styles.contentCard(isMobile),
                boxShadow: colors.cardShadow,
                display: 'flex',
                flexDirection: 'column'
              }}>
                <LearnMoreRegisterShare
                    CTLiveLink={CTLiveLink}
                    isInFutureVal={isInFutureVal}
                    forceHidingRegisterButton={forceHidingRegisterButton}
                    realURL={realURL}
                    siteURL={siteURL}
                    isMobile={isMobile}
                    showButton={displayLearnMoreOrRegisterButton}
                    t={t}
                  />
                  <ElpResults
                    event={masterEvent.currentRace}
                    isMobile={isMobile}
                  />
                  <AddEventResultsButton
                    t={t}
                    isMobile={isMobile}
                    callback={
                      () => {
                        trackGoogleEvent('ELP', 'Click', 'addMissingResults');
                        isLoggedIn() ?
                          this.addEventResultsModal()
                          : this.setState({...this.state, loginOpen: true});
                      }
                    }
                  />
                </div>
            </div>
          }
          {
            sponsorLogos.length > 0 &&
            <div className={isMobile ? 'col-12' : 'col-9 px-0'}>
              <Sponsors
                logos={sponsorLogos}
                isMobile={isMobile}
                t={t}
              />
            </div>
          }
          </div>
        </div>
      </div>
    );
  }
}

export const EventAboutPage = connect(mapStateToProps)(withTranslation()(EventAboutPageComponent));

export const LearnMoreRegisterShare =
  ({ CTLiveLink, isInFutureVal, forceHidingRegisterButton, realURL, siteURL, showButton, isMobile, t }) => {
  return (
    showButton &&
    <div id='learn-or-register-container'
         style={styles.learnMoreOrRegisterContainer(isMobile)}>
      {CTLiveLink && isInFutureVal && !forceHidingRegisterButton ?
        <Style>{ styles.hoverRegisterOrLearn(true) }
          <a
            className={'register-or-learn'}
            href={CTLiveLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackGoogleEvent('Race', 'Click', 'Register')}
            style={styles.largeButton(true, isMobile)}
          >
            {t('REGISTER')}
          </a>
        </Style>
        :
        siteURL ?
          <Style>{ styles.hoverRegisterOrLearn(false) }
            <a
              className={'register-or-learn'}
              href={realURL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGoogleEvent('Advertisements', 'Click', 'Learn More')}
              style={styles.largeButton(false, isMobile)}
            >
              {t('LEARN MORE')}
            </a>
          </Style>
          :
          null
      }
    </div>
  );
};
